// BR-1929: per-company switches on the tracking page come from company_information.action_on_tracking —
// a list such as ["delivery_address","download_pod","show_reference"]. The API may send it as an array or
// as the JSON text; .includes works on both. null means "nothing set": the two buttons show, extras don't.

export const trackingSettingOn = (companyInfo: any, setting: string): boolean =>
  companyInfo != null &&
  companyInfo.action_on_tracking != null &&
  typeof companyInfo.action_on_tracking.includes === 'function' &&
  companyInfo.action_on_tracking.includes(setting);

// IT Sameday (15437) on the old page: the customer's reference beside the tracking events.
export const SHOW_REFERENCE = 'show_reference';

// Fragilistics' POD lives in PODFather, not with us. The old page asked /ePodFather when a number was not
// found; React does the same, on the Fragilistics site only (the API enforces it too — PodFatherGuard).
export const PODFATHER_HOSTS = ['tracking.fragilistics.co.uk'];
export const podFatherHost = (): boolean => PODFATHER_HOSTS.includes(window.location.hostname.toLowerCase());

// BR-2011: a brand that shares another company's account gets its own logo by domain, not company_information.logo.
// 319 Logistics books under FITS (20516); the old page did this in css/fitz-track-319.css (.bg-logo-company).
export const HOST_LOGOS: Record<string, string> = {
  'tracking.319logistics.com': 'https://319logistics.com/wp-content/uploads/2025/04/319WEBP.webp',
};
export const hostLogo = (): string | undefined => HOST_LOGOS[window.location.hostname.toLowerCase()];

// BR-1929: the API converts some times (driver last sync) to the zone we send. This was hard-coded to
// "Asia/Calcutta" (+5:30 for UK visitors); send the visitor's own zone instead.
export const browserTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/London';
  } catch {
    return 'Europe/London';
  }
};
